"use client";

import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./index.module.scss";
import type { DateRangeFilter } from "@/types/bridge-scanner.types";

type Props = {
  dateRange: DateRangeFilter;
  setDateRange: (dateRange: DateRangeFilter) => void;
};

const ReactDatePicker = ({ dateRange, setDateRange }: Props) => {
  const [startDate, endDate] = dateRange;

  return (
    <>
      <DatePicker
        calendarClassName={styles.calendar}
        onChange={setDateRange}
        disabledKeyboardNavigation={true}
        selectsRange
        startDate={startDate}
        endDate={endDate}
        showPopperArrow={false}
        maxDate={new Date()}
        inline
      />
    </>
  );
};

export default ReactDatePicker;
